import styled from 'styled-components';

export const PrivacyContainer = styled.div`
  .privacy-auth {
    max-width: 600px;
    margin: 0 auto;
    > div:first-child {
      top: 0px !important;
    }
  }
`;

export const ShadowBox = styled.div`
  border-radius: 10px;
  box-shadow: ${({ theme, isauthpage }) => isauthpage ? 'none' : theme.boxShadow1};
  padding: 8px 12px;
  margin: 10px 0 47px 0;
`;
